import { assertGuidanceCanNavigate, highlightGuidanceTarget } from "@hereby/components";
import type { AiNavigationAction } from "@hereby/core/schemas";
import Alpine from "alpinejs";

interface AdminHost {
  activeTab: string;
  attendanceTab: string;
  leaveSubTab: string;
  orgEditMode: boolean;
  isWardOnlyAdmin: boolean;
  hasOpenOverlay(): boolean;
  switchTab(tab: string): void;
  switchAttendanceTab(tab: "work" | "leave"): void;
  switchLeaveTab(tab: "approval"): void;
}
export async function navigateAdminGuidance(
  host: AdminHost,
  action: AiNavigationAction,
  signal: AbortSignal,
) {
  if (action.version !== 1 || action.app !== "admin" || signal.aborted) {
    throw new Error("현재 앱에서 지원하지 않는 위치 안내예요.");
  }
  assertGuidanceCanNavigate();
  if (host.orgEditMode || host.hasOpenOverlay()) {
    throw new Error("작성 중인 내용을 저장하거나 취소한 뒤 다시 선택해 주세요.");
  }
  if (host.isWardOnlyAdmin) {
    throw new Error("현재 병동 관리 화면에서는 이 위치 안내를 지원하지 않아요.");
  }
  const identity = JSON.stringify(Alpine.store("hereby").currentUser);
  let tab: string;
  switch (action.targetId) {
    case "employee.register.admin":
      tab = "employees";
      break;
    case "attendance.admin":
    case "leave.approval.admin":
      tab = "attendance";
      break;
    default:
      throw new Error("이 화면의 위치 안내를 지원하지 않아요.");
  }
  if (host.activeTab !== tab) {
    host.switchTab(tab);
  }
  if (action.targetId === "leave.approval.admin") {
    host.switchAttendanceTab("leave");
    host.switchLeaveTab("approval");
  }
  if (action.targetId === "attendance.admin") {
    host.switchAttendanceTab("work");
  }
  const current = () =>
    identity === JSON.stringify(Alpine.store("hereby").currentUser) &&
    host.activeTab === tab &&
    (action.targetId !== "leave.approval.admin" ||
      (host.attendanceTab === "leave" && host.leaveSubTab === "approval")) &&
    (action.targetId !== "attendance.admin" || host.attendanceTab === "work");
  await highlightGuidanceTarget(
    () => document.querySelector(`[data-guide-id="${action.targetId}"]`),
    signal,
    current,
    {
      title: action.targetId === "employee.register.admin" ? "직원 추가" : action.label,
      description:
        action.targetId === "employee.register.admin"
          ? "이 버튼을 눌러 시작하세요."
          : "표시한 영역에서 내용을 확인하세요.",
    },
  );
}
